export const CYCLE_MS = 2 * 24 * 60 * 60 * 1000;

export function getCycleEnd() {
  const anchor = new Date('2026-01-01T00:00:00Z').getTime();
  const now = Date.now();
  const idx = Math.floor((now - anchor) / CYCLE_MS);
  return anchor + (idx + 1) * CYCLE_MS;
}

export function formatNumber(n) {
  return new Intl.NumberFormat('en-IN').format(n);
}

export function safePct(part, total) {
  if (!total) return 0;
  return Math.round((part / total) * 1000) / 10;
}

export function lighten(hex, amt = 30) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgb(${Math.min(255, r + amt)}, ${Math.min(255, g + amt)}, ${Math.min(255, b + amt)})`;
}
